import { formatPhoneBR } from 'src/modules/formatters';

import styles from './Phone.module.scss';

interface Props {
  fallback?: string;
  hideWhatsApp?: boolean;
  message?: string;
  phone: string;
  size?: string | number;
}

function Phone({ fallback, hideWhatsApp, message, phone = '', size = 16 }: Props) {
  const formattedPhone = formatPhoneBR(phone);
  let phoneNumber = phone.replace(/\D/g, '');

  if (phoneNumber.length === 10 || phoneNumber.length === 11) {
    // number has code
    phoneNumber = `55${phoneNumber}`;
  }

  const handleClick = () => {
    const link = `https://api.whatsapp.com/send?phone=${phoneNumber}${
      message ? `&text=${encodeURI(message)}` : ''
    }`;

    window.open(link, '_blank');
  };

  let output;

  if (!phoneNumber || phoneNumber.length < 10) {
    if (fallback) {
      output = <span>{fallback}</span>;
    } else {
      return null;
    }
  }

  if (formattedPhone && phoneNumber.length >= 10) {
    output = (
      <>
        <span>{formattedPhone}</span>
        {!hideWhatsApp && (
          <span onClick={handleClick} role="presentation">
            <svg
              height={size}
              preserveAspectRatio="xMidYMid"
              version="1.1"
              viewBox="0 0 128 128"
              width={size}
              xmlns="http://www.w3.org/2000/svg"
            >
              <title>WhatsApp</title>
              <g fillRule="nonzero" transform="translate(0.741313, 0.000000)">
                <path
                  d="M33.439681,109.626995 L35.5081149,110.661212 C44.1265893,115.832297 53.7792806,118.24547 63.4319721,118.24547 L63.4319721,118.24547 C93.7690025,118.24547 118.590209,93.4242634 118.590209,63.087233 C118.590209,48.6081961 112.729646,34.4738979 102.387477,24.1317286 C92.0453076,13.7895592 78.2557484,7.92899652 63.4319721,7.92899652 C33.094942,7.92899652 8.27373551,32.750203 8.6184745,63.4319721 C8.6184745,73.7741418 11.7211253,83.7715719 16.89221,92.3900466 L18.2711659,94.4584802 L12.7553422,114.79808 L33.439681,109.626995 Z"
                  fill="#00E676"
                />
                <path
                  d="M108.248039,18.6159049 C96.5269142,6.55004061 80.324182,0 63.7767112,0 C28.6133353,0 0.344738979,28.6133353 0.68947796,63.4319721 C0.68947796,74.4636195 3.79212877,85.1505278 8.96321344,94.8032193 L0,127.553422 L33.439681,118.934948 C42.7476334,124.106032 53.0898029,126.519206 63.4319721,126.519206 L63.4319721,126.519206 C98.2506092,126.519206 126.519206,97.9058701 126.519206,63.087233 C126.519206,46.1950232 119.969165,30.3370302 108.248039,18.6159049 Z M63.7767112,115.832297 L63.7767112,115.832297 C54.4687587,115.832297 45.1608063,113.419124 37.2318098,108.592778 L35.1633759,107.558562 L15.1685151,112.729646 L20.3395998,93.0795243 L18.9606439,91.0110903 C3.79212877,66.5346229 11.0316473,34.1291589 35.8528538,18.9606439 C60.6740604,3.79212877 92.7347852,11.0316473 107.903301,35.8528538 C123.071816,60.6740604 115.832297,92.7347852 91.0110903,107.903301 C83.0820942,113.074385 73.4294027,115.832297 63.7767112,115.832297 Z M94.1137411,77.5662703 L90.3216126,75.8425753 C90.3216126,75.8425753 84.8057887,73.4294027 81.3583993,71.7057077 C81.0136602,71.7057077 80.6689211,71.3609686 80.324182,71.3609686 C79.2899652,71.3609686 78.600487,71.7057077 77.9110094,72.0504468 L77.9110094,72.0504468 C77.9110094,72.0504468 77.5662703,72.3951854 72.7399245,77.9110094 C72.3951854,78.600487 71.7057077,78.9452261 71.0162296,78.9452261 L70.671491,78.9452261 C70.3267519,78.9452261 69.6372737,78.600487 69.2925346,78.2557484 L67.5688402,77.5662703 L67.5688402,77.5662703 C63.7767112,75.8425753 60.3293213,73.7741418 57.5714095,71.0162296 C56.8819314,70.3267519 55.8477146,69.6372737 55.1582369,68.947796 C52.7450638,66.5346229 50.3318912,63.7767112 48.6081961,60.6740604 L48.2634571,59.9845822 C47.9187181,59.6398436 47.9187181,59.2951045 47.5739791,58.6056263 C47.5739791,57.9161486 47.5739791,57.2266705 47.9187181,56.8819314 C47.9187181,56.8819314 49.297674,55.1582369 50.3318912,54.1240196 C51.0213688,53.434542 51.3661079,52.4003247 52.0555861,51.710847 C52.7450638,50.6766297 53.0898029,49.297674 52.7450638,48.2634571 C52.4003247,46.5397622 48.2634571,37.2318098 47.2292401,35.1633759 C46.5397622,34.1291589 45.8502842,33.78442 44.8160673,33.439681 L43.7818503,33.439681 C43.0923724,33.439681 42.0581554,33.439681 41.0239385,33.439681 C40.3344606,33.439681 39.6449826,33.78442 38.9555046,33.78442 L38.6107657,34.1291589 C37.9212877,34.4738979 37.2318098,35.1633759 36.5423318,35.5081149 C35.8528538,36.1975928 35.5081149,36.8870708 34.8186369,37.5765487 C32.4054641,40.6791995 31.0265081,44.4713283 31.0265081,48.2634571 L31.0265081,48.2634571 C31.0265081,51.0213688 31.7159861,53.7792806 32.750203,56.1924537 L33.094942,57.2266705 C36.1975928,63.7767112 40.3344606,69.6372737 45.8502842,74.8083585 L47.2292401,76.1873144 C48.2634571,77.2215312 49.297674,77.9110094 49.9871521,78.9452261 C57.2266705,85.1505278 65.5004061,89.6321344 74.8083585,92.0453076 C75.8425753,92.3900466 77.2215312,92.3900466 78.2557484,92.7347852 L78.2557484,92.7347852 C79.2899652,92.7347852 80.6689211,92.7347852 81.7031379,92.7347852 C83.4268328,92.7347852 85.4952668,92.0453076 86.8742227,91.3558294 C87.9084395,90.6663517 88.5979177,90.6663517 89.2873958,89.9768735 L89.9768735,89.2873958 C90.6663517,88.5979177 91.3558294,88.2531786 92.0453076,87.5637009 C92.7347852,86.8742227 93.4242634,86.184745 93.7690025,85.4952668 C94.4584802,84.116311 94.8032193,82.392616 95.1479584,80.6689211 C95.1479584,79.9794434 95.1479584,78.9452261 95.1479584,78.2557484 C95.1479584,78.2557484 94.8032193,77.9110094 94.1137411,77.5662703 Z"
                  fill="#FFFFFF"
                />
              </g>
            </svg>
          </span>
        )}
      </>
    );
  }

  return <div className={styles.wrapper}>{output}</div>;
}

export default Phone;
